// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/constants.ts"
);
import.meta.hot.lastModified = "1767944325094.4373";
}
// REMIX HMR END

export const APP_META_TITLE = 'Smart Laundromat Management System';
export const APP_META_DESCRIPTION =
  'A complete smart laundromat solution with real-time machine control, QR code payments, customer management, and remote monitoring to automate and grow your laundry business.';
export const DEMO_API_URL = 'https://readonlydemo.vendure.io/shop-api';
export let API_URL =
  typeof process !== 'undefined'
    ? process.env.VENDURE_API_URL ?? DEMO_API_URL
    : DEMO_API_URL;

export const SITE_URL = typeof process !== 'undefined'
    ? process.env.NEXT_PUBLIC_SITE_URL ?? 'http://localhost:8002'
    : 'http://localhost:8002';
export const OG_IMAGE = typeof process !== 'undefined'
    ? process.env.NEXT_PUBLIC_OG_IMAGE ?? 'http://localhost:8002/images/PhumLaundromat.png'
    : 'http://localhost:8002/images/PhumLaundromat.png';
export const TWITTER_SITE = typeof process !== 'undefined'
    ? process.env.NEXT_PUBLIC_TWITTER_SITE ?? '@bizsolutionkh'
    : '@bizsolutionkh';
export const TWITTER_CREATOR = typeof process !== 'undefined'
    ? process.env.NEXT_PUBLIC_TWITTER_CREATOR ?? '@bizsolutionkh'
    : '@bizsolutionkh';


/**
 * This function is used when running in Cloudflare Pages in order to set the API URL
 * based on an environment variable. Env vars work differently in CF Pages and are not available
 * on the `process` object (which does not exist). Instead, it needs to be accessed from the loader
 * context, and if defined we use it here to set the API_URL var which will be used by the
 * GraphQL calls.
 *
 * See https://developers.cloudflare.com/workers/platform/environment-variables/#environmental-variables-with-module-workers
 */
export function setApiUrl(apiUrl: string) {
  API_URL = apiUrl;
}
